module.exports = __webpack_public_path__ + "img/full1-min.c74c9459.png";